import { ICourseMetadata } from "../models/courses.models";
import { METADATA_KEY } from "./common.const";

/** Course `metadata` property names — keep in sync with `ICourseMetadata`. */
export const CourseMetadataKeys = {
  routePolyline: "routePolyline",
  isManualPolylineEdit: "isManualPolylineEdit",
} as const satisfies Record<string, keyof ICourseMetadata>;

type TCourseMetadataFormFieldPath<
  TKey extends keyof typeof CourseMetadataKeys,
> = `${typeof METADATA_KEY}.${(typeof CourseMetadataKeys)[TKey]}`;

/** React-hook-form field paths for course metadata (metadata key + field name). */
export const CourseFormFields = {
  routePolyline: `${METADATA_KEY}.${CourseMetadataKeys.routePolyline}`,
  isManualPolylineEdit: `${METADATA_KEY}.${CourseMetadataKeys.isManualPolylineEdit}`,
} as const satisfies Record<
  keyof typeof CourseMetadataKeys,
  TCourseMetadataFormFieldPath<keyof typeof CourseMetadataKeys>
>;
